import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';
import { RulStatDialogComponent } from '../rul-stat-dialog/rul-stat-dialog.component';
import * as moment from "moment-timezone";
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-rul-statistics',
  templateUrl: './rul-statistics.component.html',
  styleUrls: ['./rul-statistics.component.css']
})
export class RulStatisticsComponent implements OnInit, OnDestroy {
  @Input() entityData: any;
  isloader: boolean = false;
  pageSizeLimit: any = [];
  rulStatistictsData: any = [];
  brakeRulStat: any = [];
  clutchRulStat: any = [];
  brakeRulChart: any = [];
  clutchRulChart: any = [];
  rulStatConfig: any = {};
  datePicker = new FormControl(new Date());
  pageSize = new FormControl();
  apiHitTime: Date;
  private _rulStatisticsSubsription: Subscription;
  private _subscription: Subscription;
  constructor(
    private _service: ServicecallService,
    private _datePipe: DatePipe,
    private _entityService: EntitiesServiceService,
    private _dialog: MatDialog,
    private _dataSer: DataService
  ) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this.callBrakeClutchApi();
        this.callBrakeClutchApi('table');
      }
    });
  }

  ngOnInit(): void {
    this.pageSizeLimit = this._service.getConfiguration('pageLimits') ? this._service.getConfiguration('pageLimits')?.pageLimits : [];
    this.rulStatConfig = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig') : null;
    this.rulStatistictsData = this.rulStatConfig?.rulStatisticts.map(x => Object.assign({}, x));
    this.pageSize.setValue(this.pageSizeLimit[0]);
    this.callBrakeClutchApi();
  }

  callBrakeClutchApi(type: string = 'chart') {
    if (type === 'table') {
      this._getRulStatistics('brake');
      this._getRulStatistics('clutch');
    } else {
      this._getRulStatisticsV('brake');
      this._getRulStatisticsV('clutch');
    }
  }
  onPageLimitChange() {
    this.rulStatistictsData = this.rulStatConfig?.rulStatisticts.map(x => Object.assign({}, x));
    this.callBrakeClutchApi('table');
  }

  toggleChart(index: number, toggleType: boolean) {
    this.rulStatistictsData.map((elem: any) => elem.isChart = !elem.isChart);
    // this.rulStatistictsData[index].isChart = !this.rulStatistictsData[index].isChart;
    this.callBrakeClutchApi(toggleType ? 'table' : 'chart');
  }

  tableAction(event: any) {
    if (event?.type === 'view') {
      this._dialog.open(RulStatDialogComponent, {
        width: '60%',
        height: '80vh',
        data: { msg: 'Summary', item: event?.item },
        disableClose: true
      });
    }
  }

  onStatPaginateChange(page: number, index: number) {
    this.rulStatistictsData[index].currentRulStatPage = page;
    this._getRulStatistics(this.rulStatistictsData[index]?.rulType);
  }

  rulExport(details:any) {
    
    let reqParam = {};
    const startDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999);
    const endDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999);
    reqParam = {
      from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityData?._id,
      class: details.classType === 'brake' ? 'RUL_BRAKE_PAD' : 'RUL_CLUTCH_PAD',
      exportFormat: details?.fileType,
      timezone: sessionStorage.getItem('selectedTimeZone')?sessionStorage.getItem('selectedTimeZone'):moment.tz.guess(),
      fields: details?.classType === 'brake' ? this._service.getConfiguration('exportGenericConfig')?.brake : this._service.getConfiguration('exportGenericConfig')?.clutch
    }
    this._service.commonExport(details?.fileType, reqParam, 'rulStatsExport', 'Export_RUL_Statistics_')
    
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._rulStatisticsSubsription?.unsubscribe();  
  }
  
  private _getRulStatistics(classType: string) {
    this.apiHitTime = new Date();
    const startDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 0, 0, 0, 999);
    const endDate = new Date(this.datePicker?.value.getFullYear(), this.datePicker?.value.getMonth(), this.datePicker?.value.getDate(), 23, 59, 59, 999);
    const requestData = {
      count: this.pageSize?.value,
      from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.entityData?._id,
      class: classType === 'brake' ? 'RUL_BRAKE_PAD' : 'RUL_CLUTCH_PAD',
    };
    const page = this.rulStatistictsData?.find((elem: any) => elem?.rulType === classType)?.currentRulStatPage;
    this.isloader = true;
    this._rulStatisticsSubsription = this._entityService.rulStatistics(requestData, page).subscribe({
      next: (result: any) => {
        if (result?.data && result?.data?.length) {
          if (classType === 'brake') {
            // this.brakeRulChart = this.setChartData(result?.data, classType);
            result?.data?.map((elem: any) =>
              elem.time = this._service.getLastSeenFormat(elem.processedTime));
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'brake').totalPages = result?.pageInfo?.pages?.length ? result?.pageInfo?.pages : [];
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'brake').endPage = result?.pageInfo?.endPage;
            this.brakeRulStat = result?.data;
          } else {
            // this.clutchRulChart = this.setChartData(result?.data, classType);
            result?.data?.map((elem: any) => elem.time = this._service.getLastSeenFormat(elem.processedTime));
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'clutch').totalPages = result?.pageInfo?.pages?.length ? result?.pageInfo?.pages : [];
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'clutch').endPage = result?.pageInfo?.endPage;
            this.clutchRulStat = result?.data;
          }
        } else {
          if (classType === 'brake') {
            this.brakeRulStat = [];
            // this.brakeRulChart = [];
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'brake').totalPages = result?.pageInfo?.pages?.length ? result?.pageInfo?.pages : [];
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'brake').endPage = result?.pageInfo?.endPage;
          } else {
            this.clutchRulStat = [];
            // this.clutchRulChart = [];
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'clutch').totalPages = result?.pageInfo?.pages?.length ? result?.pageInfo?.pages : [];
            this.rulStatistictsData.find((elem: any) => elem?.rulType === 'clutch').endPage = result?.pageInfo?.endPage;
          }
        }
        this.isloader = false;
      },
      error: () => {
        this.brakeRulStat = [];
        this.clutchRulStat = [];
        this.isloader = false;
      }
    })
  }

  private _getRulStatisticsV(classType: any) {
    // const requestData = {
    //   count: +this.rulStatConfig?.rulStatisticsChartCount,
    //   entityId: this.entityData?._id,
    //   class: classType === 'brake' ? 'RUL_BRAKE_PAD' : 'RUL_CLUTCH_PAD',
    // };

    const requestDataBrake = {
      count: +this.rulStatConfig?.rulStatisticsChartCount,
      entityId: this.entityData?._id,
      class: 'RUL_BRAKE_PAD',
    };
    const requestDataClutch = {
      count: +this.rulStatConfig?.rulStatisticsChartCount,
      entityId: this.entityData?._id,
      class: 'RUL_CLUTCH_PAD',
    };
    this.isloader = true;
    this.apiHitTime = new Date();
    forkJoin([
      this._entityService.rulStatisticsV(requestDataBrake),
      this._entityService.rulStatisticsV(requestDataClutch)
    ]).subscribe({
      next: (result: any) => {
        let by1 = 0;
        let by2 = 0;
        let bx1 = 0;
        let bx2 = 0;
        let cy1 = 0;
        let cy2 = 0;
        let cx1 = 0;
        let cx2 = 0;
        if (result[0]?.data && result[0]?.data?.length) {
          this.brakeRulChart = this._setChartData(result[0]?.data, 'brake');
          by1 = result[0]?.data?.length < 1 ? 0 : result[0]?.data[0]?.rulValue;
          by2 = result[0]?.data?.length >= 1 ? (result[0]?.data[result[0]?.data?.length - 1]?.rulValue) : 0;
          bx1 = result[0]?.data?.length < 1 ? 0 : result[0]?.data[0]?.odometerValue;
          bx2 = result[0]?.data?.length >= 1 ? (result[0]?.data[result[0]?.data?.length - 1]?.odometerValue) : 0;
        } else {
          this.brakeRulChart = [];
        }
        if (result[1]?.data && result[1]?.data?.length) {
          this.clutchRulChart = this._setChartData(result[1]?.data, 'clutch');
          cy1 = result[1]?.data?.length < 1 ? 0 : result[1]?.data[0]?.rulValue;
          cy2 = result[1]?.data?.length >= 1 ? (result[1]?.data[result[1]?.data?.length - 1]?.rulValue) : 0;
          cx1 = result[1]?.data?.length < 1 ? 0 : result[1]?.data[0]?.odometerValue;
          cx2 = result[1]?.data?.length >= 1 ? (result[1]?.data[result[1]?.data?.length - 1]?.odometerValue) : 0;
        } else {
          this.clutchRulChart = [];
        }
        this.isloader = false;
        let breakCalc = Math.abs(by2 - by1) / Math.abs(bx2 - bx1);
        let clutchCalc = Math.abs(cy2 - cy1) / Math.abs(cx2 - cx1);
        let driveScore = (breakCalc + clutchCalc) / 2;
        driveScore = (typeof (driveScore) !== 'number' || driveScore === Infinity || isNaN(driveScore)) ? 1 : driveScore;
        this._dataSer.broadcast('driveScore', driveScore);
      },
      error: () => {
        this.isloader = false;
      }
    });
    // this.entityService.rulStatisticsV(requestData).subscribe({
    //   next: (result: any) => {
    //     if (result?.data && result?.data?.length) {
    //       if (classType === 'brake') {
    //         this.brakeRulChart = this.setChartData(result?.data, classType);
    //         this.dataSer.broadcast('driveScore',);
    //       } else {
    //         this.clutchRulChart = this.setChartData(result?.data, classType);
    //       }
    //     } else {
    //       if (classType === 'brake') {
    //         this.brakeRulChart = [];
    //       } else {
    //         this.clutchRulChart = [];
    //       }
    //     }
    //     this.isloader = false;
    //   },
    //   error: () => {
    //     this.isloader = false;
    //   }
    // })
  }

  private _setChartData(data: any, classType: string) {
    return [[
      {
        x: data?.map(({ processedTime }) => new Date(processedTime)),
        y: data?.map(({ odometerValue }) => odometerValue),
        name: 'Odometer(Km)',
        type: 'scatter',
        mode: 'lines+markers',
        line: {
          color: '#4BA0BE'
        },
        legend: {
          x: .8,
          y: 1.2,
          orientation: "h"
        },
        tickColor: "#4BA0BE"
      },
      {
        x: data?.map(({ processedTime }) => new Date(processedTime)),
        y: data?.map(({ rulValue }) => rulValue),
        name: classType === 'brake' ? 'Brake RUL(Km)' : 'Clutch RUL(Km)',
        yaxis: 'y2',
        type: 'scatter',
        mode: 'lines+markers',
        line: {
          color: '#CD6200'
        },
        tickColor: "#CD6200",
        autorange: false,
        upperLimit: this._service.resetRULDetials(classType === 'brake' ? 'RUL_BRAKE_PAD' : 'RUL_CLUTCH_PAD')?.lifetime
      }
    ]];
  }
}
